import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { CreateCategoriePage } from "@/features/ventes/components/categories/CreateCategoriePage";

export const Route = createFileRoute("/_app/ventes/categories/create")({
  loader: requirePermission(PERMISSIONS.VENTES.CATEGORIES.CREATE),
  staticData: {
    title: "Nouvelle catégorie",
    showInBreadcrumb: true,
  },
  component: CreateCategoriePage,
});
